import React from 'react';

import { Wrapper } from './Block.jsx';
import { BuilderBlock, EmptyPlaceholder } from '../utility/blocks';
import { withBlockRendering } from '../utility/BuilderBlock.jsx';
import Comment from './Comment.jsx';
import Name from '../utility/Name.jsx';
import TypeConfig from '../utility/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

let defaultColumnCount = 2;
function ColumnsComponent(props) {
    let columnCount = defaultColumnCount;
    let content, height;
    const containerStyle = { borderCollapse: 'separate' };
    const valign = {};
    const wrapperStyle = {};
    if (props.blockConfig) {
        if (props.blockConfig.block) {
            Utilities.mapStyleConfigProps(containerStyle, props.blockConfig.block, (propName, propValue, propUnit) => {
                switch (propName) {
                    case 'backgroundColor':
                        wrapperStyle.backgroundColor = propValue;
                        return true;
                    case 'contentColor':
                        containerStyle.backgroundColor = propValue;
                        return true;
                    case 'columnCount':
                        columnCount = parseInt(propValue, 10) || columnCount;
                        return true;
                }
            });
        }
        if (props.blockConfig.layout) {
            Utilities.mapStyleConfigProps(wrapperStyle, props.blockConfig.layout, (propName, propValue, propUnit) => {
                switch (propName) {
                    case 'height':
                        height = propValue;
                        return true;
                    case 'valign-col1':
                        valign[0] = propValue;
                        return true;
                    case 'valign-col2':
                        valign[1] = propValue;
                        return true;
                    case 'valign-col3':
                        valign[2] = propValue;
                        return true;
                }
            });
        }
    }
    if (height) {
        if (containerStyle.borderTopWidth && containerStyle.borderTopStyle != 'none') {
            const temp = parseInt(containerStyle.borderTopWidth, 10);
            if (!isNaN(temp)) {
                height -= temp;
            }
        }
        if (containerStyle.borderBottomWidth && containerStyle.borderBottomStyle != 'none') {
            const temp = parseInt(containerStyle.borderBottomWidth, 10);
            if (!isNaN(temp)) {
                height -= temp;
            }
        }
        containerStyle.height = `${height}px`;
    }
    let columnWidth = 600;
    if (containerStyle.borderLeftWidth && containerStyle.borderLeftStyle != 'none') {
        const temp = parseInt(containerStyle.borderLeftWidth, 10);
        if (!isNaN(temp)) {
            columnWidth -= temp;
        }
    }
    if (containerStyle.borderRightWidth && containerStyle.borderRightStyle != 'none') {
        const temp = parseInt(containerStyle.borderRightWidth, 10);
        if (!isNaN(temp)) {
            columnWidth -= temp;
        }
    }
    columnWidth /= columnCount;
    if (props.blocks) {
        content = props.blocks.map((d, i) => {
            return (
                <ColumnContainer
                    key={i}
                    {...props}
                    blocks={d}
                    blockType="column"
                    columnCount={columnCount}
                    height={containerStyle.height}
                    index={i}
                    inLayout={true}
                    valign={valign}
                    width={columnWidth} />
            )
        });
    }
    if (props.builder) {
        content = <div style={{ height: '100%' }}>{content}</div>
    }
    content = (
        <Wrapper {...props} containerStyle={containerStyle} isLayout={true} style={wrapperStyle}>
            {
                props.renderMso &&
                <Comment document={props.frameDoc} id={`${props.blockId}-columns-top`} value={`<!--[if (gte mso 9)|(IE)]><table align="center" border="0" cellspacing="0" cellpadding="0" width="600" style="display:inline-table;width:600px;"><tr><![endif]-->`} />
            }
            {content}
            {
                props.renderMso &&
                <Comment document={props.frameDoc} id={`${props.blockId}-columns--bottom`} value={`<!--[if (gte mso 9)|(IE)]></tr></table><![endif]-->`} />
            }
        </Wrapper>
    )
    if (props.builder) {
        content = (
            <>
                <BuilderBlock blockType="column" {...props}>
                    {content}
                    <div className="drag-outline drag-outline-layout drag-outline-layout-parent" />
                </BuilderBlock>
                {
                    props.dragging &&
                    <div id={`${props.blockId}-hidden`} className="hidden draggable" onDragEnter={props.onDragEnter} />
                }
            </>
        );
    }
    return content;
}
const ColumnsTypeConfig = {
    panel: {
        block: function () {
            const group = 'design';
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Background Color',
                        group,
                        name: 'backgroundColor',
                        type: 'color'
                    },
                    {
                        display: 'Content Background Color',
                        group,
                        name: 'contentColor',
                        type: 'color'
                    },
                    {
                        display: 'Column Count',
                        group,
                        name: 'columnCount',
                        options: [
                            { display: '1', value: 1 },
                            { display: '2', value: 2 },
                            { display: '3', value: 3 }
                        ],
                        type: 'dropdown',
                        value: defaultColumnCount
                    },
                    {
                        display: 'Border Radius',
                        group,
                        name: 'borderRadius',
                        options: TypeConfig.options.measurement(true),
                        type: 'measurement'
                    },
                    {
                        display: 'Border',
                        group,
                        name: 'border',
                        options: TypeConfig.options.measurement(),
                        type: 'border'
                    }
                ]
            }
        },
        layout: function () {
            const group = 'layout';
            return {
                group,
                label: 'Layout',
                options: [
                    {
                        display: 'Padding Top',
                        fullWidth: true,
                        group,
                        max: '100',
                        name: 'paddingTop',
                        options: TypeConfig.options.measurement(),
                        type: 'measurement-slider'
                    },
                    {
                        display: 'Padding Bottom',
                        fullWidth: true,
                        group,
                        max: '100',
                        name: 'paddingBottom',
                        options: TypeConfig.options.measurement(),
                        type: 'measurement-slider'
                    },
                    {
                        display: 'Height',
                        fullWidth: true,
                        group,
                        max: '1000',
                        name: 'height',
                        options: TypeConfig.options.measurement(),
                        type: 'measurement-slider'
                    },
                    {
                        fullWidth: true,
                        group,
                        type: 'info',
                        value: '* Vertical Alignment only available when Height is set',
                        visible: (config) => !config.layout || !config.layout.height || !config.layout.height.value
                    },
                    {
                        display: 'Col 1 Vertical Alignment',
                        group,
                        name: 'valign-col1',
                        options: TypeConfig.options.valign(),
                        type: 'dropdown',
                        value: 'top',
                        visible: (config) => config.layout && config.layout.height && config.layout.height.value
                    },
                    {
                        display: 'Col 2 Vertical Alignment',
                        group,
                        name: 'valign-col2',
                        options: TypeConfig.options.valign(),
                        type: 'dropdown',
                        value: 'top',
                        visible: (config) => config.block && (config.block.columnCount == '2' || config.block.columnCount == '3') && config.layout && config.layout.height && config.layout.height.value
                    },
                    {
                        display: 'Col 3 Vertical Alignment',
                        group,
                        name: 'valign-col3',
                        options: TypeConfig.options.valign(),
                        type: 'dropdown',
                        value: 'top',
                        visible: (config) => config.block && config.block.columnCount == '3' && config.layout && config.layout.height && config.layout.height.value
                    }
                ]
            }
        }
    }
};
const ColumnsBlockTypeDefinition = (group) => {
    return {
        id: Name.Block.Column,
        config: {
            block: ColumnsTypeConfig.panel.block(),
            blocks: [[], []],
            layout: ColumnsTypeConfig.panel.layout()
        },
        dataBlockType: 'container',
        dataType: 'layout',
        display: 'Columns',
        group,
        image: 'columns.png'
    };
};
const Columns = { BlockTypeDefinition: ColumnsBlockTypeDefinition, Component: ColumnsComponent, TypeConfig: ColumnsTypeConfig };

function _ColumnContainer(props) {
    const blocks = props.blocks || [];
    const columnWidth = 600 / (props.columnCount || 1);
    const dataType = 'layout-vertical';
    const maxWidth = props.width || 300;

    let id;
    let className = 'Content';
    let content = props.onBlockRendering(blocks, (d) => {
        const blockProps = { columnWidth, frameDoc: props.frameDoc, maxWidth, renderMso: props.renderMso };
        if (!d.type) {
            return blockProps;
        }
        switch (d.type.value) {
            case Name.Block.Inventory.Text:
                blockProps.inCell = props.inCell;
            // Intentional fallthrough
            case Name.Block.Artist.Text:
            case Name.Block.Contact.Image:
            case Name.Block.Contact.Message:
            case Name.Block.Contact.Offer:
            case Name.Block.Contact.Text:
            case Name.Block.Inventory.Image:
            case Name.Block.ResourceText:
                blockProps.data = props.config && props.config.data || props.data;
                break;
        }
        return blockProps;
    });
    if (props.builder) {
        className += ' layout-cont layout-child';
        id = `${props.blockId}-child-${props.index}`;
        content = (
            <div
                className={className}
                data-block-type={props.blockType}
                data-type={dataType}
                id={id}
                style={{ display: 'flex', flexDirection: 'column' }}>
                {
                    props.builder &&
                    props.dragging &&
                    <div id={`${id}-hidden-first`}
                        className="hidden hidden-child-first draggable"
                        data-type={dataType}
                        style={{ minHeight: '10px', width: '100%' }}
                        onDragEnter={props.onDragEnter} />
                }
                {content}
                {
                    props.builder &&
                    <>
                        {
                            blocks.length == 0 &&
                            !props.dragging &&
                            <EmptyPlaceholder minWidth="100%" />
                        }
                        {
                            props.dragging &&
                            <div id={`${id}-hidden`}
                                className="hidden hidden-child-last draggable"
                                data-type={dataType}
                                style={{ marginTop: blocks.length == 0 ? '10px' : undefined, minHeight: '10px', width: '100%' }}
                                onDragEnter={props.onDragEnter} />
                        }
                    </>
                }
            </div>
        )
    }
    const style = { display: 'inline-table', minHeight: '1px' };
    let valign;
    if (props.height) {
        style.height = props.height;
        valign = props.valign && props.valign[props.index];
    }
    return (
        <>
            {
                props.renderMso &&
                <Comment document={props.frameDoc} id={`${props.blockId}-${props.index}-top`} value={`<!--[if (gte mso 9)|(IE)]><td align="center" valign="top" width="${maxWidth}" style="width:${maxWidth}px;"><![endif]-->`} />
            }
            {
                props.builder &&
                props.index > 0 &&
                <div className="drag-outline-layout-child" style={{ left: `calc(${Math.round((props.index / props.columnCount) * 600)}px + 100px)` }} />
                // <div className="drag-outline-layout-child" style={{ left: `${Math.round(props.index * 100 / props.columnCount)}%` }} />
            }
            <table
                align="left"
                border="0"
                cellPadding="0"
                cellSpacing="0"
                className="columnWrapper"
                style={style}
                width={maxWidth}>
                <tbody>
                    <tr>
                        <td className="columnContainer" valign={valign || "top"}>
                            {content}
                        </td>
                    </tr>
                </tbody>
            </table>
            {
                props.renderMso &&
                <Comment document={props.frameDoc} id={`${props.blockId}-${props.index}-top`} value={`<!--[if (gte mso 9)|(IE)]></td><![endif]-->`} />
            }
        </>
    )
}
const ColumnContainer = withBlockRendering(_ColumnContainer);

export default Columns;